export default __webpack_public_path__ + "static/media/combineHarvestor.2b7da64a.jpg";